import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { DarkCard, LightCard } from '../components/Cards';
import { ImageDecorations } from '../components/Decorations';
export function Workshop() {
  const CTA_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSd1jwlLel_orq9QCQyytJb0Ur2k3xXmPrVXy_qoxQnjjcw9Rg/viewform';
  return <main className="flex-grow bg-rise-white" data-id="element-1209">
      {/* SECȚIUNEA 1 — HERO */}
      <section className="py-12 md:py-20 px-6 bg-rise-white overflow-hidden" data-id="element-1210">
        <div className="max-w-rise-content mx-auto flex justify-center" data-id="element-1211">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center max-w-3xl" data-id="element-1212">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-1213">
              WORKSHOP ONLINE GRATUIT
            </span>
            <h1 className="font-playfair text-[36px] md:text-[52px] text-rise-black leading-tight mb-6" data-id="element-1214">
              Descoperă în 90 de minute ce ai în tine ca să nu mai aștepți din
              exterior
            </h1>

            <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mx-auto leading-relaxed mb-10" data-id="element-1215">
              Un workshop practic și transformațional, pentru tineri adulți care
              se simt blocați, nesiguri sau copleșiți și vor să descopere
              resursele pe care le au deja în ei: curaj, claritate, echilibru,
              încredere. Nu teorie. Exerciții reale, lucru în grup și un pas
              concret cu care pleci acasă.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-8 mb-10 font-dm-sans text-[15px] text-rise-black w-full" data-id="element-1216">
              <div className="flex flex-col items-center" data-id="element-1217">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1218">
                  Data și ora
                </span>
                <span data-id="element-1219">[De confirmat]</span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-gray-300" data-id="element-1220"></div>
              <div className="flex flex-col items-center" data-id="element-1221">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1222">
                  Platforma
                </span>
                <span data-id="element-1223">Online, Zoom</span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-gray-300" data-id="element-1224"></div>
              <div className="flex flex-col items-center" data-id="element-1225">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1226">
                  Durata
                </span>
                <span data-id="element-1227">90 minute</span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-gray-300" data-id="element-1228"></div>
              <div className="flex flex-col items-center" data-id="element-1229">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1230">
                  Preț
                </span>
                <span className="font-bold" data-id="element-1231">GRATUIT</span>
              </div>
            </div>

            <div className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-1232">
              <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors flex items-center justify-center w-full mb-3" data-id="element-1233">
                Rezervă-ți Locul Gratuit la Workshop
              </a>
              <p className="font-dm-sans text-[14px] text-rise-gray/70 italic" data-id="element-1234">
                Locuri limitate pentru a păstra calitatea experienței.
                Înscrie-te acum.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — PROBLEMA */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-1235">
        <div className="max-w-rise-content mx-auto" data-id="element-1236">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-center mb-12 max-w-3xl mx-auto" data-id="element-1237">
            Ce se întâmplă când nu știi că resursele sunt deja în tine...
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-1238">
            <div className="space-y-6 font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-1239">
              <p data-id="element-1240">
                Te trezești dimineața cu același gând: nu știu ce vreau, nu știu
                dacă pot, nu știu de unde să încep.
              </p>
              <p data-id="element-1241">
                Îți spui că nu ești pregătit, că alții sunt mai buni, că mai
                aștepți puțin.
              </p>
              <p data-id="element-1242">
                Amâni o decizie importantă: un proiect, o colaborare, o
                schimbare, o conversație dificilă.
              </p>
              <p data-id="element-1243">
                Simți că pierzi ocazii reale nu pentru că nu ești capabil, ci
                pentru că nu ai încredere că ești.
              </p>
              <p data-id="element-1244">
                Te uiți la ceilalți și te întrebi de unde au ei curajul,
                claritatea sau forța de care tu crezi că duci lipsă.
              </p>
              <p data-id="element-1245">
                Cauți răspunsuri în exterior: în opinii, în validare, în ce zic
                alții că ar trebui să faci.
              </p>
              <p className="text-rise-gold font-medium text-[22px] italic mt-8" data-id="element-1246">
                Și tot nu te miști. Nu pentru că nu poți. Ci pentru că nu știi
                că ceea ce ai nevoie este deja în tine.
              </p>
            </div>

            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-8 md:p-10" data-id="element-1247">
              <p className="font-dm-sans text-[19px] text-rise-white/90 leading-relaxed mb-8" data-id="element-1248">
                Am văzut asta de zeci de ori în 9 ani de lucru cu tineri. Oameni
                capabili, inteligenți, cu potențial real, blocați de o singură
                lipsă: nu știau ce resurse au în ei și cum să le folosească. De
                aceea am creat acest workshop.
              </p>
              <div className="flex flex-col items-center" data-id="element-1249">
                <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-3 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors inline-flex items-center justify-center w-full text-center mb-3" data-id="element-1250">
                  Rezervă-ți Locul Gratuit la Workshop
                </a>
                <p className="font-dm-sans text-[13px] text-rise-white/50 italic text-center" data-id="element-1251">
                  Locuri limitate pentru a păstra calitatea experienței.
                  Înscrie-te acum.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — CE VEI ÎNVĂȚA */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-1252">
        <div className="max-w-rise-content mx-auto" data-id="element-1253">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-16" data-id="element-1254">
            Ce descoperi și practici în acest workshop de 90 de minute
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1255">
            <div className="flex items-start gap-4" data-id="element-1256">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1257">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1258">1</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1259">
                Vei identifica exact ce resurse interioare ai activat deja în
                viața ta, fără să fi știut că o faci, și de ce funcționează.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1260">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1261">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1262">2</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1263">
                Vei înțelege cum curajul, claritatea, determinarea sau
                echilibrul nu sunt trăsături cu care te naști, ci resurse pe
                care le poți accesa oricând.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1264">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1265">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1266">3</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1267">
                Vei exersa, prin exerciții ghidate, cum să activezi o resursă
                specifică exact când ai nevoie de ea: într-un moment copleșitor,
                înainte de o decizie sau când vocea interioară îți spune că nu
                poți.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1268">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1269">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1270">4</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1271">
                Vei lucra în camere de grup pe Zoom și vei auzi experiențele
                altor oameni care trec prin situații similare cu ale tale. Vei
                înțelege că nu ești singurul și că soluția nu e atât de departe.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1272">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1273">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1274">5</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1275">
                Vei pleca cu o resursă personală clară identificată și cu un
                exercițiu simplu pe care îl poți folosi singur de a doua zi.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1276">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1277">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1278">6</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1279">
                Vei simți ce înseamnă energia unui grup care lucrează împreună
                spre același scop: claritate, curaj și progres fără judecată.
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-1280">
            <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center mb-3" data-id="element-1281">
              Rezervă-ți Locul Gratuit la Workshop
            </a>
            <p className="font-dm-sans text-[14px] text-rise-gray/70 italic" data-id="element-1282">
              Locuri limitate pentru a păstra calitatea experienței. Înscrie-te
              acum.
            </p>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — CUM SE SCHIMBĂ VIAȚA TA */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite" data-id="element-1283">
        <div className="max-w-rise-content mx-auto" data-id="element-1284">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-white text-center mb-16" data-id="element-1285">
            Ce se schimbă după acest workshop
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1286">
            <DarkCard title="Nu mai cauți în exterior ce ai în tine" data-id="element-1287">
              <p data-id="element-1288">
                Știi exact cum să accesezi curajul, claritatea sau echilibrul de
                care ai nevoie, fără să aștepți validare, condiții perfecte sau
                momentul potrivit.
              </p>
            </DarkCard>
            <DarkCard title="Iei decizii fără să te blochezi" data-id="element-1289">
              <p data-id="element-1290">
                Nu mai pierzi oportunități din lipsă de încredere. Înveți să
                acționezi cu resursele pe care le ai deja, nu cu cele pe care
                crezi că îți lipsesc.
              </p>
            </DarkCard>
            <DarkCard title="Știi că nu ești singur în proces" data-id="element-1291">
              <p data-id="element-1292">
                Energia și poveștile grupului îți arată că blocajele tale nu
                sunt unice. Și că alți oameni ca tine au trecut prin ele, cu
                exact aceleași resurse pe care tu le ai deja.
              </p>
            </DarkCard>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — CINE SUNT EU */}
      <section className="py-12 md:py-20 px-6 bg-rise-white overflow-hidden" data-id="element-1293">
        <div className="max-w-rise-content mx-auto" data-id="element-1294">
          <div className="max-w-3xl mx-auto" data-id="element-1295">
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-8" data-id="element-1296">
              Cine sunt eu și de ce am creat acest workshop pentru tine
            </h2>
            <div className="space-y-6 font-dm-sans text-[19px] text-rise-gray leading-relaxed mb-10" data-id="element-1297">
              <p data-id="element-1298">
                Sunt <strong data-id="element-1299">Teodora Trifu</strong>, consilier pentru dezvoltare
                personală cu 9 ani de experiență în lucrul cu tineri. Sunt
                formată ca lucrător prin arte combinate și folosesc metode
                experiențiale și creative care combină autocunoașterea cu
                acțiunea concretă.
              </p>
              <p data-id="element-1300">
                De 5 ani construiesc, prin ONG-ul pe care l-am fondat, spații
                sigure în care tinerii din medii defavorizate învață să se
                cunoască și să se susțină pe ei înșiși.
              </p>
              <p data-id="element-1301">
                Am văzut același tipar de zeci de ori: oameni capabili care se
                blochează nu pentru că nu au resurse, ci pentru că nu știu că le
                au. O kinetoterapeută care știa că poate vorbi cu pacienții ei,
                dar o voce interioară o oprea mereu. Un freelancer care evita să
                lanseze proiecte proprii de teamă că nu e suficient de bun. Un
                tânăr absolvent blocat la primul pas dintr-un drum necunoscut.
              </p>
              <p className="font-playfair italic text-rise-gold text-[22px]" data-id="element-1302">
                Toți aveau ce le trebuia. Pur și simplu nu știau unde să caute.
              </p>
              <p data-id="element-1303">
                Am creat acest workshop ca să te ajut să găsești tu însuți ce ai
                în tine, într-un spațiu sigur, alături de un grup care înțelege
                exact prin ce treci.
              </p>
            </div>
            <div className="flex flex-col items-start" data-id="element-1304">
              <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center mb-3" data-id="element-1305">
                Rezervă-ți Locul Gratuit la Workshop
              </a>
              <p className="font-dm-sans text-[14px] text-rise-gray/70 italic" data-id="element-1306">
                Locuri limitate pentru a păstra calitatea experienței.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite" data-id="element-1307">
        <div className="max-w-rise-content mx-auto grid md:grid-cols-2 gap-12 md:gap-20" data-id="element-1308">
          {/* Pentru cine ESTE */}
          <div data-id="element-1309">
            <h2 className="font-playfair text-[32px] text-rise-white mb-8 border-b border-rise-gold/30 pb-4" data-id="element-1310">
              Pentru cine este acest workshop
            </h2>
            <div className="space-y-6" data-id="element-1311">
              <div className="flex items-start gap-4" data-id="element-1312">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={24} data-id="element-1313" />
                <p className="font-dm-sans text-[18px] text-rise-white/80 leading-relaxed" data-id="element-1314">
                  Tineri adulți între 20 și 35 de ani care simt că au potențial,
                  dar ceva din interior îi oprește și vor să înțeleagă ce anume.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1315">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={24} data-id="element-1316" />
                <p className="font-dm-sans text-[18px] text-rise-white/80 leading-relaxed" data-id="element-1317">
                  Oameni care trec printr-o perioadă aglomerată sau copleșitoare
                  și au nevoie de claritate și de instrumente simple ca să
                  meargă mai departe.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1318">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={24} data-id="element-1319" />
                <p className="font-dm-sans text-[18px] text-rise-white/80 leading-relaxed" data-id="element-1320">
                  Oricine a pierdut sau evitat o oportunitate importantă din
                  lipsă de încredere în sine și vrea să schimbe asta concret, nu
                  doar teoretic.
                </p>
              </div>
            </div>
          </div>

          {/* Pentru cine NU ESTE */}
          <div data-id="element-1321">
            <h2 className="font-playfair text-[32px] text-rise-white mb-8 border-b border-white/10 pb-4" data-id="element-1322">
              Pentru cine nu este acest workshop
            </h2>
            <div className="space-y-6" data-id="element-1323">
              <div className="flex items-start gap-4" data-id="element-1324">
                <XCircle className="text-rise-white/40 shrink-0 mt-1" size={24} data-id="element-1325" />
                <p className="font-dm-sans text-[18px] text-rise-white/60 leading-relaxed" data-id="element-1326">
                  Pentru cei care caută motivație temporară sau citate
                  inspiraționale, fără să fie dispuși să lucreze efectiv pe ei
                  în cadrul exercițiilor.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1327">
                <XCircle className="text-rise-white/40 shrink-0 mt-1" size={24} data-id="element-1328" />
                <p className="font-dm-sans text-[18px] text-rise-white/60 leading-relaxed" data-id="element-1329">
                  Pentru cei care vor o soluție pasivă, să asculte un curs și să
                  nu participe la exerciții sau la lucrul în grup.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1330">
                <XCircle className="text-rise-white/40 shrink-0 mt-1" size={24} data-id="element-1331" />
                <p className="font-dm-sans text-[18px] text-rise-white/60 leading-relaxed" data-id="element-1332">
                  Pentru cei care cred că resursele interioare nu există și că
                  totul depinde exclusiv de circumstanțe externe. Acest workshop
                  pornește de la premisa că ai deja ce îți trebuie.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 7 — TESTIMONIALE */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-1333">
        <div className="max-w-rise-content mx-auto" data-id="element-1334">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-16" data-id="element-1335">
            Ce spun oamenii care au lucrat cu mine
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1336">
            <LightCard title="Kinetoterapeut" data-id="element-1337">
              <p className="italic mb-4" data-id="element-1338">
                "Știam că pot, dar ceva mă oprea de fiecare dată. După ce am
                lucrat cu Teodora, am înțeles de unde vine acea frică și am
                învățat să o gestionez. Acum vorbesc cu pacienții mei relaxat și
                deschis."
              </p>
            </LightCard>
            <LightCard title="Mela" data-id="element-1339">
              <p className="italic mb-4" data-id="element-1340">
                "M-ai ajutat să descopăr perspective noi și să îmi dezvolt
                abilitățile de a face față provocărilor. Am descoperit lucruri
                noi despre mine și am învățat să îmi gestionez emoțiile în
                momentele în care nu eram în zona mea de confort."
              </p>
            </LightCard>
            <LightCard title="Marina-Georgiana Burz" data-id="element-1341">
              <p className="italic mb-4" data-id="element-1342">
                "Apreciez foarte mult aceste workshop-uri pe care le faceți.
                Sunt interactive, motivaționale și educative. Cu siguranță multe
                persoane se simt ascultate acum."
              </p>
            </LightCard>
            <LightCard title="Alina Nicoleta" data-id="element-1343">
              <p className="italic mb-4" data-id="element-1344">
                "Vreau să te felicit, Teo. Îmi place că ai o voce caldă și
                liniștită — inspiri siguranță."
              </p>
            </LightCard>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 8 — CTA FINAL */}
      <section className="py-14 md:py-24 bg-rise-black text-center relative overflow-hidden px-6" data-id="element-1345">
        <div className="absolute inset-0 opacity-10 pointer-events-none flex items-center justify-center" data-id="element-1346">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold rounded-full" data-id="element-1347"></div>
          <div className="absolute w-[600px] h-[600px] border-[1px] border-rise-gold rounded-full" data-id="element-1348"></div>
          <div className="absolute w-[400px] h-[400px] border-[1px] border-rise-gold rounded-full" data-id="element-1349"></div>
        </div>

        <div className="max-w-rise-content mx-auto relative z-10" data-id="element-1350">
          <h2 className="font-playfair text-[36px] md:text-[48px] text-rise-white mb-10" data-id="element-1351">
            Ești gata să descoperi ce ai deja în tine?
          </h2>
          <div className="flex flex-col items-center" data-id="element-1352">
            <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-10 py-5 rounded-xl font-dm-sans font-semibold text-[18px] transition-colors inline-flex items-center justify-center mb-4" data-id="element-1353">
              Rezervă-ți Locul Gratuit la Workshop
            </a>
            <p className="font-dm-sans text-[16px] text-rise-white/70 italic" data-id="element-1354">
              Locurile sunt limitate pentru a păstra calitatea lucrului în grup
              și a camerelor de Zoom. Înscrie-te acum și rezervă-ți locul.
            </p>
          </div>
        </div>
      </section>
    </main>;
}